import React, { FC } from 'react';
import classNames from 'classnames';

interface CardActionsProps {
  className?: string;
}

export const CardActions: FC<CardActionsProps> = ({ className, children }) => (
  <div
    className={classNames('card__actions flex flex-col sm:flex-row sm:flex-wrap gap-2 md:gap-3 lg:gap-4', className)}
  >
    {children}
  </div>
);
